import React from 'react';
import InquiryPic from "./inquiries.jpg";

function Inquiries() {
    return (
        <div className="inquiries">
            <div className="relative mb-12">
                <img
                    className="h-96 w-full object-cover object-center rounded-b-2xl shadow-2xl"
                    src={InquiryPic}
                    alt="A beautiful landscape"
                    loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-b-2xl"></div>
                <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center w-full px-4">
                    <h1
                        className="text-4xl md:text-5xl font-extrabold text-white mb-3 text-center tracking-tight shadow-sm"
                    >
                        Get Professional Assitance
                    </h1>
                    <span
                        className="px-6 py-3 rounded-full shadow-xl text-lg font-semibold bg-[#3d0707] text-white transform hover:scale-105 transition-transform duration-300"
                    >
                        Channel all questions/concerns
                    </span>
                </div>
            </div>

            <div className='container my-5'>
                <h1 className='flex flex-col font-black leading-none text-gray-800 uppercase dark:text-white text-center'>Submit your Inquiry</h1>

                {/* <div className='flex flex-col justify-center items-center'>
                    <a href='/contact' className='text-decoration-none text-white bg-black px-4 py-2 hover:font-bold'>Submit</a>
                </div> */}
            </div>
        </div>
    );
}

export default Inquiries;